import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    isLoaderShow = false;
    constructor() {}

    hideLoader(): void {
        this.isLoaderShow = false;
    }

    showLoader(): void {
        this.isLoaderShow = true;
    }
}
